import { useState } from "react";
import { withRouter } from "react-router-dom";
import { Dialog, TableRow, TableCell, Tooltip, IconButton } from "@material-ui/core";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import moment from "moment";
import { useSnackbar } from "notistack";
import { dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import ShowAttachments from "../../../../shared_elements/components/ShowAttachments";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { permissionCheckFnforCamo, checkApiStatus } from "../../../../utils";
import { globalGetService, globalPutService, globalDeleteService } from "../../../../utils/globalApiServices";
import { acumenCamo } from "../../../../shared_elements/components";

const AmpList = ({ item, toggleModalFn, toggleDelteModalFn, downloadAllApi, getResponseBack, }) => {
	const { enqueueSnackbar } = useSnackbar();
	const [openAttachmentsDialog, setOpenAttachmentsDialog] = useState(false);
	const [allAttachments, setAllAttachments] = useState(null);
	const [lessMore, setLessMore] = useState({});

	let timezone = moment().format();
	const timestamp = Math.floor(Date.now() / 1000);
	const ampurl = `audit/camo/ampcompliance/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`;

	const mergeAttachments = ({ attachments = [], checklist } = {}) => {
		const files = checklist?.files || [];
		const folders = checklist?.folders || [];
		return [...attachments, ...files, ...folders];
	};

	const fetchAndShowAttachments = () => {
		globalGetService(`camo/amp/view/${item.id}/`).then((response) => {
			if (checkApiStatus(response)) {
				const data = response.data.data;
				const merged = mergeAttachments(data);
				if (merged.length > 0) {
					setAllAttachments(merged);
					setOpenAttachmentsDialog(true);
				}
			}
		});
	};

	const refreshAttachments = () => {
		globalGetService(`camo/amp/view/${item.id}/`).then((response) => {
			if (checkApiStatus(response)) {
				const data = response.data.data;
				const merged = mergeAttachments(data);
				if (merged.length > 0) {
					setAllAttachments(merged);
					setOpenAttachmentsDialog(true);
				}
				getResponseBack();
			}
		});
	};

	const removeAttachment = (item, checklist, fileId, uuid) => {
		if (uuid) {
			const payload = {
				delete: true,
				folder_ids: checklist.filter(i => i.type === 'folder').map(f => f.id).filter(id => id !== fileId).toString(),
				file_ids: checklist.filter(i => i.type === 'file').map(f => f.id).filter(id => id !== fileId).toString(),
			};
			globalPutService(`camo/amp/${item.id}/document-checklists/`, payload).then((response) => {
				if (checkApiStatus(response)) refreshAttachments();
			});
		} else {
			globalDeleteService(`camo/attachment/${fileId}/delete/`).then((response) => {
				if (response.status === 500) {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				} else {
					refreshAttachments();
				}
			});
		}
	};

	const getAttachmentCount = () => {
		const total = mergeAttachments(item).length;
		return total > 0 ? total : '--';
	};

	const toggleLessMore = (key) => setLessMore(prev => ({ ...prev, [key]: !prev[key] }));

	const lessMoreFn = (name, key) => (
		<>
			{name && name.length > 35 ? (
				<>
					{lessMore[key] ? (
						<>
							{name}
							<span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..less</span>
						</>
					) : (
						<>
							{name.substring(0, 35)}
							<span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(key); }}> ..more</span>
						</>
					)}
				</>
			) : name || '--'}
		</>
	);

	const attachmentCount = getAttachmentCount();

	return (
		<>
			<TableRow hover tabIndex={-1} style={{ cursor: "pointer" }} className="engine-module-table" >
				<TableCell>
					<div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
						{permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "U" }) ? (
							<Tooltip title="Edit" arrow placement="top">
								<CreateOutlinedIcon color="primary" className="amp-table__edit-icon" onClick={toggleModalFn} />
							</Tooltip>
						) : null}
						{permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "D" }) ||
							permissionCheckFnforCamo({ primaryKey: "amp_compliance", keyIndex: "OD", userId: item.created_by }) ? (
							<Tooltip title="Delete" arrow placement="top">
								<DeleteOutlinedIcon color="secondary" className="amp-table__delete-icon" onClick={toggleDelteModalFn} />
							</Tooltip>
						) : null}
						<RevisionHistory buttonType={true} url={ampurl} />
					</div>
				</TableCell>
				<TableCell>{item.MPD_item_no || "--"}</TableCell>
				<TableCell>{item.task_card_no || "--"}</TableCell>
				<TableCell>{item.previous_LDND_Taskcard || "--"}</TableCell>
				<TableCell>{lessMoreFn(item?.Task_Description, "Task_Description")}</TableCell>
				<TableCell>{item.threshold_D || "--"}</TableCell>
				<TableCell>{item.threshold_FH || "--"}</TableCell>
				<TableCell>{item.threshold_FC || "--"}</TableCell>
				<TableCell>{item.interval_D || "--"}</TableCell>
				<TableCell>{item.interval_FH || "--"}</TableCell>
				<TableCell>{item.interval_FC || "--"}</TableCell>
				<TableCell>{item.lastDone_D ? moment(item.lastDone_D).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</TableCell>
				<TableCell>{item.lastDone_FH || "--"}</TableCell>
				<TableCell>{item.lastDone_FC || "--"}</TableCell>
				<TableCell>{item.nextDue_D ? moment(item.nextDue_D).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"}</TableCell>
				<TableCell>{item.nextDue_FH || "--"}</TableCell>
				<TableCell>{item.nextDue_FC || "--"}</TableCell>
				<TableCell>{item.remainingValues_D || "--"}</TableCell>
				<TableCell>{item.remainingValues_FH || "--"}</TableCell>
				<TableCell>{item.remainingValues_FC || "--"}</TableCell>
				<TableCell>{lessMoreFn(item?.remarks, "remarks")}</TableCell>
				<TableCell>
					{attachmentCount !== '--' ? (
						<Tooltip title="View Attachments">
							<span className="center" onClick={fetchAndShowAttachments}>
								<AttachFileIcon className="amp-table__attach-icon" />
								<a href="#" style={{ color: "#0e7fe1" }}>{attachmentCount}</a>
							</span>
						</Tooltip>
					) : "--"}
				</TableCell>
			</TableRow>

			<Dialog
				open={openAttachmentsDialog}
				onClose={() => setOpenAttachmentsDialog(false)}
				id="htDialog"
			>
				<ShowAttachments
					handleClose={() => setOpenAttachmentsDialog(false)}
					handleShowAttachments={allAttachments}
					openAttachment={(file) => window.open(decodeURIComponent(file), "_blank")}
					files={{ title: "AMP", extension: "zip", key: "" }}
					downloadAllApi={downloadAllApi}
					moduleId={item.id}
					item={item}
					removeAttachment={removeAttachment}
					editFormId={item.id}
				/>
			</Dialog>
		</>
	);
};

export default withRouter(AmpList);
